import { useTranslation } from "react-i18next";
import { AssessmentCheckboxRadio } from "ui-components";
import "./AdvanceSetting.scss";
interface JobTypeSelector {
  setJobType: any;
  jobType: any;
}
const JobTypeSelector: React.FC<JobTypeSelector> = ({
  setJobType,
  jobType,
}) => {
  const { t } = useTranslation();
  return (
    <div className="jobType">
      <span className="comSubLabel">{t("GENERAL.ENGAGEMENT")}</span>
      <div className="jobTypeRow mt-3">
        <div
          className="d-flex jobTypeCursorPointer rtlGap"
          onClick={() => {
            setJobType((prev: any) => {
              const updatedData = { ...prev, engagementType: "fullTime" };
              sessionStorage.setItem(
                "advanceSettingData",
                JSON.stringify(updatedData),
              );
              return updatedData;
            });
          }}
        >
          <AssessmentCheckboxRadio
            name="fullTime"
            type="radio"
            checked={jobType?.engagementType == "fullTime"}
          />
          <p className="radioCheckLabel">{t("CREATE_ASSESSMENT.FULLTIME")}</p>
        </div>
        <div
          className="d-flex jobTypeCursorPointer rtlGap"
          onClick={() => {
            setJobType((prev: any) => {
              const updatedData = { ...prev, engagementType: "partTime" };
              sessionStorage.setItem(
                "advanceSettingData",
                JSON.stringify(updatedData),
              );
              return updatedData;
            });
          }}
        >
          <AssessmentCheckboxRadio
            name="partTime"
            type="radio"
            checked={jobType?.engagementType == "partTime"}
          />
          <p className="radioCheckLabel">{t("CREATE_ASSESSMENT.PARTTIME")}</p>
        </div>
        <div
          className="d-flex jobTypeCursorPointer rtlGap"
          onClick={() => {
            setJobType((prev: any) => {
              const updatedData = { ...prev, engagementType: "contract" };
              sessionStorage.setItem(
                "advanceSettingData",
                JSON.stringify(updatedData),
              );
              return updatedData;
            });
          }}
        >
          <AssessmentCheckboxRadio
            name="contract"
            type="radio"
            checked={jobType?.engagementType == "contract"}
          />
          <p className="radioCheckLabel">{t("CREATE_ASSESSMENT.CONTRACT")}</p>
        </div>
        <div
          className="d-flex jobTypeCursorPointer rtlGap"
          onClick={() => {
            setJobType((prev: any) => {
              const updatedData = { ...prev, engagementType: "internship" };
              sessionStorage.setItem(
                "advanceSettingData",
                JSON.stringify(updatedData),
              );
              return updatedData;
            });
          }}
        >
          <AssessmentCheckboxRadio
            name="internship"
            type="radio"
            checked={jobType?.engagementType == "internship"}
          />
          <p className="radioCheckLabel">{t("CREATE_ASSESSMENT.INTERNSHIP")}</p>
        </div>
      </div>
    </div>
  );
};

export default JobTypeSelector;
